<template>
  
  <div class="1">
    <div class="title-icon">大模型必备Python语言</div>
    <div class="main-content">
      <div class="block">Python语法</div>
      <div class="block">Python面向对象</div>
      <div class="block">Python API</div>
    </div>

    <div class="title-icon">大模型必备AI基础</div>
    <div class="main-content">
      <div class="block">Pytorch基础</div>
      <div class="block">Transformer基础</div>
    </div>

    <div class="title-icon">大模型课程背景</div>
    <div class="main-content">
      <div class="block">LM及LLM概念</div>
      <div class="block">基于Transformer预训练语言模型主要方法</div>
    </div>

    <div class="title-icon">大模型开发流程</div>
    <div class="main-content-flow">
      <h1 class="title">
        <i></i>
        <p>01-大模型开发项目流程及团队构成</p>
      </h1>
      <div class="top1">
        <h2>项目流程</h2>
        <span>
          <a
            >原始数据<img
              src="../../../../assets/coursePage/ai2/box6/arrow.png"
          /></a>
          <a
            >数据处理<img
              src="../../../../assets/coursePage/ai2/box6/arrow.png"
          /></a>
          <a
            >模型评估<img
              src="../../../../assets/coursePage/ai2/box6/arrow.png"
          /></a>
          <a
            >模型构建<img
              src="../../../../assets/coursePage/ai2/box6/arrow.png"
          /></a>
          <a>模型上线</a>
        </span>
      </div>
      <div class="top1 top2">
        <h2>团队构成</h2>
        <span>
          <a style="width: 100%">AI开发，产品，测试等</a>
        </span>
      </div>
      <div class="bottom">
        <h1 class="title">
          <i></i>
          <p>02-模型构建</p>
        </h1>
        <div class="content">
          <div class="wrapper">
            <h1>· 大模型主要类型架构</h1>
            <span>
              <a>自编码模型Encoder-only</a>
              <a>自回归模型Decoder-only</a>
              <a>序列到序列模型Encoder-Decoder</a>
            </span>
          </div>
          <div class="wrapper">
            <h1>· 主流大模型介绍</h1>
            <span>
              <a>ChatGPT模型</a>
              <a>LLaMA模型</a>
              <a>ChatGLM模型</a>
              <a>BLOOM模型</a>
            </span>
          </div>
          <div class="wrapper">
            <h1>· 大模型应用方式（微调+知识库）</h1>
            <span>
              <a>LLM的进阶历程</a>
              <a>大模型应用的问题</a>
              <a>传统Fine-Tuning方式</a>
              <a>Prompt-Tuning发展方式</a>
              <a>面向超大规模模型的Prompt-Tuning</a>
            </span>
          </div>
        </div>
      </div>
      <div class="bottom">
        <h1 class="title">
          <i></i>
          <p>03-模型评估</p>
        </h1>
        <div class="content">
          <div class="wrapper">
            <span>
              <a>语言模型的3大评价指标——BLEU、ROUGE、PPL</a>
              <a>精确率、召回率、F1值</a>
            </span>
          </div>
        </div>
      </div>
      <div class="bottom">
        <h1 class="title">
          <i></i>
          <p>04-模型上线</p>
        </h1>
        <div class="content">
          <div class="wrapper">
            <span>
              <a>模型部署和上线</a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
            
</template>

<script>
import pageTitle from "../../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  mounted() {},
  
  methods: {
    openDetail() {
      
    },
    
  },
};
</script>

<style lang="less" scoped>
@import "index.less";

</style>
